import { FilterBuilder, type FilterBuilderProps } from "@tfg/ui"

import {
  useFiltersOperatorsLabelsTranslations,
  useFiltersOperatorsValuesResolver,
  useFiltersSlidingPresetsLabelsTranslations,
} from "~/hooks/useFiltersOperatorsTranslations"

export type FilterBuilderWrapperProps<T> = Omit<
  FilterBuilderProps<T>,
  | "operatorLabelTranslationMapping"
  | "dateValueLabelResolver"
  | "slidingPresetLabelTranslationMapping"
>

export function FilterBuilderWrapper<
  T extends Partial<Record<string, unknown>>,
>(props: FilterBuilderWrapperProps<T>) {
  const operatorLabelTranslationMapping =
    useFiltersOperatorsLabelsTranslations()

  const slidingPresetLabelTranslationMapping =
    useFiltersSlidingPresetsLabelsTranslations()

  const dateValueLabelResolver = useFiltersOperatorsValuesResolver(
    slidingPresetLabelTranslationMapping
  )

  return (
    <FilterBuilder
      {...props}
      operatorLabelTranslationMapping={operatorLabelTranslationMapping}
      slidingPresetLabelTranslationMapping={
        slidingPresetLabelTranslationMapping
      }
      dateValueLabelResolver={dateValueLabelResolver}
    />
  )
}
